import api from '../utils/api';

// Fetch all staff histories
export const getAllStaffHistories = async (headers) => {
  try {
    const response = await api.get('/api/staffHistory', headers);
    console.log("getAllStaffHistories", response.data);
    return response.data;
  } catch (error) {
    console.error('Error fetching all staff histories:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Fetch a specific staff history by ID
export const getStaffHistoryById = async (id, headers) => {
  try {
    const response = await api.get(`/api/staffHistory/${id}`, headers);
    console.log("get one staff history by id", response.data);
    return response.data;
  } catch (error) {
    console.error('Error fetching staff history by ID:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Update staff history by ID
export const updateStaffHistory = async (id, staffHistoryData, headers) => {
  try {
    const response = await api.put(`/api/staffHistory/${id}`, staffHistoryData, headers);
    return response.data;
  } catch (error) {
    console.error('Error updating staff history:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Delete staff history by ID
export const deleteStaffHistory = async (id, headers) => {
  try {
    const response = await api.delete(`/api/staffHistory/${id}`, headers);
    return response.data;
  } catch (error) {
    console.error('Error deleting staff history:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Fetch staff histories by staffId
export const getStaffHistoryByStaffId = async (staffId, headers) => {
  try {
    const response = await api.get(`/api/staffHistory/staff/${staffId}`, headers);
    return response.data;
  } catch (error) {
    console.error('Error fetching staff history by staff ID:', error.response ? error.response.data : error.message);
    throw error;
  }
};
